module.exports = __webpack_public_path__ + "static/media/vizcomexample2.cc310611.jpg";